import { IGuest_EventNew } from '@bridebook/models/source/models/Weddings/Guests.types';
import {
  addedGuestAnalytics,
  addedMultipleGuestsAnalytics,
  deletedGuestAnalytics,
  deletedMultipleGuestsAnalytics,
  clickedAddGuestsAnalytics,
  clickedToShareGuestCollectorLinkAnalytics,
  initialisedGuestlistAnalytics,
  interactedWithGuestsOnGuestlistAnalytics,
  sharedGuestCollectorLinkAnalytics,
  toggleBulkAddGuestsMethodAnalytics,
} from '@bridebook/web/lib/guestlist/analytics/actions';

export enum GuestlistAnalyticsActionTypes {
  INITIALISED_GUESTLIST = '[Analytics] Guestlist initialised',
  TOGGLE_BULK_ADD_METHOD = '[Analytics] Toggle bulk add guests method',
  CLICKED_ADD_GUESTS = '[Analytics] Clicked to add guests',
  ADDED_MULTIPLE_GUESTS = '[Analytics] Added multiple guests',
  DELETED_MULTIPLE_GUESTS = '[Analytics] Deleted multiple guests',
  OPENED_GUEST_COLLECTOR_POPUP = '[Analytics] Opened guest collector popup',
  CLOSED_GUEST_COLLECTOR_POPUP = '[Analytics] Closed guest collector popup',
  CLICKED_TO_SHARE_GUEST_COLLECTOR_LINK = '[Analytics] Clicked to share guest collector link',
  SHARED_GUEST_COLLECTOR_LINK = '[Analytics] Shared guest collector link',
  INTERACTED_WITH_GUESTS_ON_GUESTLIST = '[Analytics] Interacted with guests on guestlist',
  CLICKED_EDIT_GUEST = '[Analytics] Clicked edit guest',
  CLICKED_TO_EDIT_GUEST_CATEGORY = '[Analytics] Clicked to edit guest category',
  FAILED_TO_DELETE_GUEST_CATEGORY = '[Analytics] Failed to delete guest category',
  CLICKED_TO_DELETE_CATEGORY = '[Analytics] Clicked to delete category',
  DELETED_CATEGORY = '[Analytics] Deleted category',
  CANCELLED_DELETE_GUEST = '[Analytics] Cancelled delete guest',
  ADDED_GUEST = '[Analytics] Added guest',
  EDITED_GUEST = '[Analytics] Edited guest',
  FAILED_TO_ADD_GUEST = '[Analytics] Failed to add guest',
  CLICKED_DELETE_GUEST = '[Analytics] Clicked delete guest',
  DELETED_GUEST = '[Analytics] Deleted guest',
  CLICKED_RESET_GUESTLIST = '[Analytics] Clicked reset guestlist',
  TOGGLED_GUESTLIST_FILTERS = '[Analytics] Toggled guestlist filters',
  RESET_GUESTLIST = '[Analytics] Reset guestlist',
  TOGGLED_GUESTLIST_SEARCH = '[Analytics] Toggled guestlist search',
  USED_GUESTLIST_SEARCH = '[Analytics] Used guestlist search',
  CANCELLED_RESET_GUESTLIST = '[Analytics] Cancelled reset guestlist',
  EXPORT_GUESTLIST = '[Analytics] Export guestlist',
  UPDATED_GUEST_CATEGORY = '[Analytics] Updated guestlist category',
}

export type AddedMultipleGuestsAnalyticsAction = ReturnType<typeof addedMultipleGuestsAnalytics>;

export type DeletedMultipleGuestsAnalyticsAction = ReturnType<
  typeof deletedMultipleGuestsAnalytics
>;

export type DeletedGuestAnalyticsAction = ReturnType<typeof deletedGuestAnalytics>;

export type AddedGuestAnalyticsAction = ReturnType<typeof addedGuestAnalytics>;

export type InitialisedGuestlistAnalyticsAction = ReturnType<typeof initialisedGuestlistAnalytics>;

export type ToggleBulkAddGuestsMethodAnalyticsAction = ReturnType<
  typeof toggleBulkAddGuestsMethodAnalytics
>;

export type ClickedAddGuestsAnalyticsAction = ReturnType<typeof clickedAddGuestsAnalytics>;

export type SharedGuestCollectorLinkAnalyticsAction = ReturnType<
  typeof sharedGuestCollectorLinkAnalytics
>;

export type InteractedWithGuestsOnGuestlistAnalyticsAction = ReturnType<
  typeof interactedWithGuestsOnGuestlistAnalytics
>;

export interface InteractedWithGuestsOnGuestlistAnalyticsPayload {
  guestAction: 'added' | 'deleted' | 'edited' | 'clicked';
  guestMethod: 'popover' | 'missingEmailHyperlink' | 'emailHyperlink';
  guestCount?: number;
  guestGroupId?: string;
  guestGroupName?: string;
  guestId?: string;
  guestName?: string;
  guestInvitations?: Record<
    string,
    {
      type: 'mainEvent' | 'customEvent';
      invited: boolean;
      rsvp: IGuest_EventNew['rsvp'];
    }
  >;
  category?: string;
}

export type ClickedToShareGuestCollectorLinkAnalyticsAction = ReturnType<
  typeof clickedToShareGuestCollectorLinkAnalytics
>;

export interface ClickedToShareGuestCollectorLinkAnalyticsPayload {
  collectGuestInfoPopupLocation: 'guestInterior' | 'guestExterior' | 'guestList' | 'guestComms';
  elementLabel?: string;
  element?: string;
  section?: string;
  category?: string;
}
